<template>
  <el-dialog
    title="登录"
    custom-class="tianfuDialogo"
    :close-on-click-modal="false"
    :visible.sync="$store.state.login.loginDialogVisible"
  >
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
      <el-form-item prop="username">
        <el-input
          prefix-icon="el-icon-user-solid"
          v-model.trim="ruleForm.username"
          autocomplete="off"
          placeholder="请输入账号"
          @keydown.enter.native="submitForm('ruleForm')"
          clearable
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          prefix-icon="el-icon-lock"
          show-password
          v-model.trim="ruleForm.password"
          autocomplete="off"
          @keydown.enter.native="submitForm('ruleForm')"
          placeholder="请输入密码"
          clearable
        />
      </el-form-item>
      <el-form-item prop="captchaCode">
        <div class="codeBox">
          <el-input
            v-model="ruleForm.captchaCode"
            autocomplete="off"
            placeholder="请输入验证码"
            style="width: 60%"
            clearable
            @keydown.enter.native="submitForm('ruleForm')"
          ></el-input>
          <img
            :src="captchaSrc"
            @click="refreshCaptcha"
            alt="验证码"
            class="captcha-img"
            title="点击刷新验证码"
          />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          class="loginBTN"
          type="primary"
          @click="submitForm('ruleForm')"
          >登 录</el-button
        >
      </el-form-item>
      <div v-if="loginMsg" class="errorMsg">
        <span>{{loginMsg}}</span>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  loginPlatform,
  getRolesMenus,
  getVerificationCode,
} from '@/API/login/login';

export default {
  name: 'index',
  data() {
    return {
      ruleForm: {
        username: '',
        password: '',
        captchaCode: '',
        deviceId: '',
        appkey: 't-app-cdc@1002', // 前台项目应用key
      },
      loginMsg: undefined,
      rules: {
        username: [
          { required: true, trigger: 'change', message: '请输入账号' },
        ],
        password: [
          { required: true, trigger: 'change', message: '请输入密码' },
        ],
        captchaCode: [
          { required: true, trigger: 'blur', message: '请输入验证码' },
        ],
      },
      captchaSrc: '',
    };
  },
  mounted() {
    this.handleBeforeUnload();
    this.refreshCaptcha();
  },
  methods: {
    // 刷新验证码
    refreshCaptcha() {
      this.ruleForm.deviceId = JSON.stringify(new Date().getTime());
      getVerificationCode(this.ruleForm.deviceId)
        .then((res) => {
          const base64 = btoa(
            new Uint8Array(res).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              '',
            ),
          );
          this.captchaSrc = `data:image/png;base64,${base64}`;
        })
        .catch((error) => {
          console.error('获取验证码失败:', error);
          this.$message.error('验证码加载失败，请重试');
        });
    },

    // 表单验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
    // 登录
    login() {
      const loading = this.$loading(this.loadingText);
      loginPlatform(this.ruleForm).then((res) => {
        if (res.code === 200) {
          this.$message.success('登录成功!');
          this.$store.commit('changeOrdinaryUser', res.data);
          this.$store.commit('SET_OrdinaryLoggedIn', true);
          localStorage.setItem('ordinaryToken', res.data.accessToken);
          this.getMenusList();
          window.location.reload();
          this.$store.commit('login/changeLoginDialogVisible', false);
          this.loginMsg = undefined
        } else {
          if(res.code == 110) {
            this.loginMsg = `${res.message},请重新输入!`
          }else {
            this.loginMsg = res.message
          }

        }
      });
      this.uploadInputInfo()
      loading.close();
    },
    uploadInputInfo() {
      this.$refs.ruleForm.resetFields()
      this.refreshCaptcha();
    },
    getMenusList() {
      getRolesMenus().then((res) => {
        if (res.code === 200) {
          this.$store.commit('login/changeMenus', res.data);
          console.log('用户权限菜单获取成功');
        } else {
          this.$message.error(`用户权限菜单获取失败：${res.message}`);
        }
      });
    },
    handleBeforeUnload() {
      let loginStatus = false;
      try {
        const storedValue = localStorage.getItem('ordinaryLoggedIn');
        loginStatus = storedValue ? JSON.parse(storedValue) : false;
      } catch (e) {
        console.error('Error parsing login status:', e);
        loginStatus = false;
      }
      if (loginStatus) {
        getRolesMenus().then((res) => {
          if (res.code === 200) {
            this.$store.commit('login/changeMenus', res.data);
            console.log('用户权限菜单获取成功1111');
          } else {
            this.$message.error(`用户权限菜单获取失败：${res.message}`);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.tianfuDialogo {
  margin-top: 30vh !important;
  width: 475px;
}
.el-form {
  padding: 0 30px !important;
}
.loginBTN {
  width: 100%;
}

.codeBox {
  display: flex;
  align-items: center;

  .captcha-img {
    width: 35%;
    height: 40px;
    margin-left: 5%;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;

    &:hover {
      border-color: #409eff;
      opacity: 0.8;
    }
  }
}
.errorMsg{
  color: #e06262;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 768px) {
  /deep/.tianfuDialogo {
    width: 90% !important;
  }
  .loginBTN {
    font-size: 16px !important;
  }

  .codeBox {
    .captcha-img {
      height: 36px;
    }
  }
}
</style>
